<template>
    <div>
        <tracker-new-data-header v-if="!editTarget" :columns="columns"></tracker-new-data-header>
        <div v-if="canTrackManually" class="row px-3 new-data-inputs">
            <div class="col-2 px-1 py-3">
                <v-date-picker
                    dusk="date"
                    placeholder="MM/DD/YYYY"
                    id="date"
                    class="picker-container"
                    popover-align="left"
                    v-model="date"
                ></v-date-picker>
            </div>
            <div class="p-1 col-4">
                <input
                    type="text"
                    v-model.number="score"
                    @keyup.enter="pushScore()"
                    name="score"
                    class="custom-input"
                    style="max-width: 2rem;"
                />
                <a
                    class="btn btn-sm btn-outline-primary"
                    v-tooltip="'Add data'"
                    @click="pushScore()"
                    ><i class="text-primary fa fa-plus"></i
                ></a>
                <a
                    class="btn btn-sm btn-outline-primary"
                    v-tooltip="'Remove last'"
                    @click="popScore()"
                    ><i class="text-primary fa fa-minus"></i
                ></a>
                {{ scores.length ? scores : "" }}
            </div>
            <div class="p-1 col-5">
                <input v-model="note" class="form-control form-control-sm" name="note" />
            </div>
            <tracker-new-data-actions
                :saving="saving"
                :edit-target="editTarget"
                @save-data="submitData()"
                @edit-done="$emit('edit-done')"
            ></tracker-new-data-actions>
        </div>
    </div>
</template>

<script>
import { trackerNewDataCommon } from "./trackerNewDataCommon";

export default {
    name: "TrackerNewDataCme",
    mixins: [trackerNewDataCommon],
    data() {
        return {
            columns: {
                titles: [`Date`, `Scores`, `Note`, ``],
                col: [2, 4, 5, 1],
            },
            date: new Date(),
            success: 0,
            score: null,
            scores: [],
            note: "",
        };
    },

    async mounted() {
        if (this.editTarget) {
            this.populateEdit();
        }
    },

    beforeDestroy() {
        this.resetComponent();
    },

    methods: {
        populateEdit() {
            let editTarget = { ...this.editTarget };
            this.date = editTarget.session_at;
            this.note = editTarget.notes;
            this.success = this.editTarget.data.success;
            this.scores = this.editTarget.data.scores;
            this.score = this.editTarget.data.score;
        },

        pushScore() {
            if (isNaN(this.score)) {
                this.$swal("Error", `The values must be numbers.`, "error");
                return;
            }
            this.scores.push(this.score);
            this.score = null;
        },

        popScore() {
            this.score = this.scores.pop();
        },

        submitData() {
            let success = 0;

            if (this.goal.parameters.evaluate === "average" && this.scores.length !== 0) {
                const sum = this.scores.reduce((a, b) => a + b);
                success = Math.round(sum / this.scores.length);
            }
            if (this.goal.parameters.evaluate === "max" && this.scores.length !== 0) {
                success = Math.max.apply(null, this.scores);
            }

            const payload = {
                data: {
                    type: "cme",
                    scores: this.scores,
                    success: success,
                },
                notes: this.note,
                session_at: this.isoDate,
            };

            this.$emit("save-data", payload);
        },

        resetComponent() {
            this.date = new Date();
            this.success = 0;
            this.scores = [];
            this.note = "";
            this.score = null;
        },
    },
};
</script>

<style scoped></style>
